import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../lib/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      const next = location.state?.from || (res.user?.role === "admin" ? "/admin" : "/my-snapshot");
      navigate(next, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 relative" data-testid="login-page">
      <Helmet>
        <title>Sign in · The Entity Agency</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <div
        aria-hidden
        className="absolute -top-40 right-1/4 w-[400px] h-[400px] rounded-full opacity-[0.05] pointer-events-none"
        style={{ background: "radial-gradient(circle at center, #b8963e 0%, transparent 60%)" }}
      />
      <div className="w-full max-w-md relative">
        <p className="overline">Sign in</p>
        <h1 className="mt-3 font-serif-display text-5xl text-[#f4efe6]" style={{fontWeight: 700}}>
          Welcome <em className="text-[#b8963e] italic font-normal">back.</em>
        </h1>
        <p className="mt-4 text-sm text-[#c9bca4]">
          Access your snapshots, history, and downloadable reports.
        </p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline-soft">Email</label>
            <input
              type="email" required autoComplete="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 eav-input"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="overline-soft">Password</label>
            <input
              type="password" required autoComplete="current-password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 eav-input"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-[#c46a5a] bg-[#c46a5a]/10 border border-[#c46a5a]/30 rounded-md px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit-button"
            className="w-full h-12 btn-gold justify-center"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#8a7e6d]">
          No account?{" "}
          <Link to="/signup" data-testid="login-to-signup" className="text-[#b8963e] hover:text-[#d4ae4a]">Create one</Link>
        </p>
      </div>
    </div>
  );
}
